export default {
  loadTickets: "[irb] load tickets",
  loadTicketsSuccess: "[irb] load tickets success",
  loadTicketsError: "[irb] load tickets error",
  loadExternalLink: "[irb] load external link"
};
